import { render, staticRenderFns } from "./SourceNews.vue?vue&type=template&id=b6d4f4f6&scoped=true&"
import script from "./SourceNews.vue?vue&type=script&lang=js&"
export * from "./SourceNews.vue?vue&type=script&lang=js&"
import style0 from "./SourceNews.vue?vue&type=style&index=0&id=b6d4f4f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d4f4f6",
  null
  
)

export default component.exports